import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/movie";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <button
          type="button"
          onClick={() => goTo("top")}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
            <i className="ri-movie-2-line text-background-50 text-lg"></i>
          </span>
          <span
            className={`font-heading text-lg md:text-xl font-bold tracking-wide transition-colors ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            岳母的诱惑
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <button
              key={link.id}
              type="button"
              onClick={() => goTo(link.id)}
              className={`px-3 py-2 text-sm rounded-md whitespace-nowrap cursor-pointer transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  : "text-background-100 hover:text-background-50 hover:bg-foreground-950/20"
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex">
          <button
            type="button"
            onClick={() => goTo("guide")}
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            立即观看
          </button>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => goTo(link.id)}
                className="text-left px-3 py-2.5 text-sm rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
              >
                {link.label}
              </button>
            ))}
            <button
              type="button"
              onClick={() => goTo("guide")}
              className="mt-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
            >
              立即观看
            </button>
          </div>
        </div>
      )}
    </header>
  );
}